<template>
  <div>
    <table v-if="userEfforts.length" class="acada-table resourcing">
      <colgroup>
        <col style="width: 30%" />
        <col
          v-for="header in intervalHeaders"
          :key="header"
          :style="{ width: `${70 / intervalHeaders.length}%` }"
        />
      </colgroup>

      <thead>
        <tr>
          <th>{{titleHeader}}</th>
          <th
            v-for="(header, i) in intervalHeaders"
            :key="i"
            class="interval-header"
          >
            {{ moment(header, 'DD-MM-YYYY').format('MMM') }}
            <div>{{ moment(header, 'DD-MM-YYYY').format('YYYY') }}</div>
            <div
              v-if="header === fyEndInterval"
              class="fy-end-indicator"
              v-tooltip="{
                content: 'Financial Year End',
                delay: { show: 300, hide: 0 },
                classes: 'large',
              }"
            />
          </th>
        </tr>
      </thead>

      <tr v-for="user of userEfforts" :key="user.id">
        <td>
          {{ user.fullName }}
          <span>{{ user.teamId && categories[user.teamId].name }}</span>
        </td>
        <td v-for="header in intervalHeaders" :key="header">
          <load-indicator
            :load="user.intervals[header] ? (user.intervals[header].effort || 0) : 0"
            size="36px"
            :tooltip="getUserLoadSummaryPopover(user.intervals[header], user.fte)"
          />
        </td>
      </tr>
    </table>
    <div v-else class="no-data">No data to show</div>
  </div>
</template>

<script>
import moment from 'moment';
import LoadIndicator from "@/components/LoadIndicator";
import fy_months from "@/utils/fy_months";
import {mapGetters} from "vuex";

export default {
  name: "ResourcingTable",
  components: {LoadIndicator},
  props: {
    titleHeader: {
      type: String,
      default: 'Name'
    },
    titleHeaderKey: {
      type: String,
      default: 'name'
    },
    intervalHeaders: {
      type: Array,
      default: () => ([])
    },
    intervalsKey: {
      type: String,
      default: 'intervals'
    },
    resources: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    moment,
    yearEnding: new Date().getFullYear()
  }),
  methods: {
    getUserLoadSummaryPopover(userInterval, userFte) {
      try {
        if (!userInterval) {
          return '';
        }
        let projects = userInterval.projects ? userInterval.projects.map(proj => {
          const mappedProj = this.projectMap[proj.id] || {shortId: 'Unknown', name: 'Unknown'};
          return {
            text: `${mappedProj.shortId} ${mappedProj.name}`,
            proportionalEffort: proj.effort
          }
        }) : [];

        projects.sort((a, b) => b.proportionalEffort - a.proportionalEffort);

        if (projects.length > 5) {
          let total = 0;
          let count = 0;
          for (let i = 5; i < projects.length; i++) {
            count++;
            total += projects[i].proportionalEffort;
          }
          projects.splice(5, Infinity, {text: `${count} More`, proportionalEffort: total})
        }

        let html = ``;

        html += `<div class="large">`;

        html += `<h6><span>Total load:</span> ${Math.round(userInterval.effort * 100)}%${userFte ? ` (${userFte} FTE)` : ''}</h6>`;

        projects.forEach(project => {
          html += `<h6><span>${project.text}:</span> ${Math.round(project.proportionalEffort * 100)}%</h6>`;
        });

        html += `</div>`;

        return html;
      }
      catch (e) {
        console.error(e);
      }
    }
  },
  computed: {
    ...mapGetters(['app_user', 'rootCategory', 'categories']),
    is_super_admin() {
      return this.app_user && this.app_user.role === 'SuperAdmin';
    },
    fyEndInterval() {
      let ret;
      const fyEndMonth = fy_months(this.$store.getters.org.fy_month, new Date().getFullYear()).prev_month;
      for (let i = 0; i < this.intervalHeaders.length; i++) {
        const intervalDate = moment(this.intervalHeaders[i], 'DD-MM-YYYY');
        if (intervalDate.format('MMM') === fyEndMonth) ret = this.intervalHeaders[i];
      }
      return ret;
    },
    projectMap() {
      if (!this.resources.projects) return {};
      return this.resources.projects.reduce((obj, curr) => {
        obj[curr.id] = curr;
        return obj;
      }, {})
    },
    userResourcesMap() {
      if (!this.resources.projectMembers) return {};
      return this.resources.projectMembers.reduce((obj, curr) => {
        obj[curr.id] = curr;
        return obj;
      }, {})
    },
    userEfforts() {
      return Object.values(this.$store.getters.activeUsers)
        .filter(user => (user.jobTitle === 'Procurement'))
        .map(user => ({
          id: user.id,
          fullName: `${user.firstName} ${user.lastName}`,
          categoryId: user.categoryId,
          teamId: user.categoryId && this.rootCategory[user.categoryId],
          fte: this.userResourcesMap[user.id] ? this.userResourcesMap[user.id].fte : undefined,
          intervals: this.userResourcesMap[user.id] ? this.userResourcesMap[user.id].intervals.reduce((obj, curr) => {
            obj[curr.intervalStart] = curr;
            return obj;
          }, {}) : [],
          projectIds: this.userResourcesMap[user.id] ? this.userResourcesMap[user.id].projectIds : []
        }))
        .sort((a, b) => a.fullName.localeCompare(b.fullName));
    }
  }
}
</script>

<style scoped>
/*TODO: Set no-data color*/
/*@import '../styles/_styles.scss';*/
.no-data {
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin: 30px 0;
  /*color: $sidebar-color;*/
  opacity: 0.5;
}

.interval-header {
  position: relative;
  text-align: center;
}

.fy-end-indicator {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 2px;
  background-color: #C2C7D4;
}
</style>
